module.exports = __webpack_public_path__ + "img/profile-user-gray.64e8a125.svg";